export function SolidityIcon({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        viewBox="0 0 128 128"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
      >
        <path d="M64.8 0L35.4 50.1 64.8 100.2l29.4-50.1L64.8 0zm0 18.7l17.4 31.4-17.4 31.4-17.4-31.4L64.8 18.7zM35.4 77.9L64.8 128l29.4-50.1-29.4-50.1-29.4 50.1zm29.4 12.4l17.4-31.4-17.4-31.4-17.4 31.4 17.4 31.4z" />
      </svg>
    );
  }
  